
var site = site || {};
site.Search = (() => {
    // Functions

    // var functionName = () => {
    //
    // };

    const toggleSearchBox = () => {
        const searchToggle = document.querySelector('.js-toggle-search');
        
        searchToggle.addEventListener('click', (event) => {
            event.preventDefault();
            const searchBox = document.querySelector('.js-global-search');
            const icon = searchToggle.querySelector('svg');
            const searchMask = document.querySelector('.js-global-search-mask');
            const searchInput = document.querySelector('.js-keyword');
            // Swap search toggle icon
            icon.classList.toggle('fa-magnifying-glass');
            icon.classList.toggle('fa-xmark');
            // Activate search 
            searchBox.classList.toggle('active');
            searchMask.classList.toggle('active');
            // Allow animation to end before giving search input focus
            setTimeout(() => {
                searchInput.focus();
            }, 1000);
        })
    }


    const searchResults = () => {
        const openTrigger = document.querySelectorAll('.js-submit-search');

        openTrigger.forEach((el, i) => {
            el.addEventListener('click', () => {

                const prevSibling = el.previousElementSibling;
                const searchBox = prevSibling.querySelector('.js-keyword');
                var keyword = searchBox.value;
                var url = "/search?keyword=" + keyword;

                location.href = url;
            })
        });

        const keywordInputField = document.querySelectorAll('.js-keyword');

        keywordInputField.forEach((el, i) => {
            el.addEventListener('keyup', (e) => {
                if (e.keyCode == 13) {
                    var keyword = el.value;
                    var url = "/search?keyword=" + keyword;

                    location.href = url;
                }
            })
        });
    }

    // Return
    return {
        toggleSearchBox: toggleSearchBox,
        searchResults: searchResults
    };
})();